import { render, staticRenderFns } from "./glovo_general_tab.vue?vue&type=template&id=2372926d&scoped=true&"
import script from "./glovo_general_tab.vue?vue&type=script&lang=js&"
export * from "./glovo_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372926d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2372926d')) {
      api.createRecord('2372926d', component.options)
    } else {
      api.reload('2372926d', component.options)
    }
    module.hot.accept("./glovo_general_tab.vue?vue&type=template&id=2372926d&scoped=true&", function () {
      api.rerender('2372926d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/glovo/location/tabs/glovo_general_tab.vue"
export default component.exports